import React from "react";
import { Card, Divider } from "antd";
import { 
  Clock 
} from "lucide-react";
import { formatDateRange } from "utils/index";
import ApprovalButtons from "components/button/approvalbuttons";
import { MODULE_OVERTIME_REQUESTS } from "variables/constants";
import OvertimeApprovalForm from "./OvertimeApprovalForm";

const OvertimeRequestCard = (props) => {
  const overtime = { ...props };

  return (
    <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-xl border border-orange-200 hover:shadow-md transition-shadow dark:bg-black/5">
      <div className="flex justify-between items-start relative gap-4">
        <div className="flex items-center space-x-3 ">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-semibold ">
            {overtime?.ots_employee_initials}
          </div>
          <div>
            <div className="flex flex-row gap-2">
              <h3 className="font-semibold text-slate-900 dark:text-white">{overtime?.ots_employee_name}</h3>
              <span className="status-indicator normal text-[10px] px-2 dark:text-white">{overtime?.ots_employee?.emp_code}</span>
            </div>
            <div className="flex items-center text-slate-700 text-sm dark:text-slate-100">{overtime?.ots_employee?.emp_title}</div>
          </div>
        </div>
      </div>

      {overtime?.ots_status_id === 66 ?
        <>
          <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-2">
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">From</p>
              <div className="flex items-center gap-1">
                <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(overtime?.date_time_start, null, true, true, true)}</span>
              </div>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">To</p>
              <div className="flex items-center gap-1">
                <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(overtime?.date_time_end, null, true, true, true)}</span>
              </div>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Overtime Hours</p>
              <div className="flex items-center gap-1">
                <Clock className="w-4 h-4 text-purple-600 dark:text-purple-400" />
                <span className="text-[13px] font-medium tracking-normal dark:text-white">{overtime?.duration_string}</span>
              </div>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Rquested On</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(overtime?.created_at, null, false)}</span>
            </div>
          </div>

          <div>
            <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Reason</p>
            <p className="text-[13px] font-medium dark:text-white">{overtime?.ots_reason}</p>
          </div>

          <Divider style={{ margin: "1rem 0", borderColor: "#e5e7eb" }} />

          <div className="pb-6">
            <div className="absolute right-1 gap-3 pr-6">
              <ApprovalButtons
                record={overtime}
                recordIdKey="ots_id"
                employeeNameKey="ots_employee_name"
                moduleId={MODULE_OVERTIME_REQUESTS}
                FormComponent={OvertimeApprovalForm}
                modalPrefix="edit_overtime_request"
              />
            </div>
          </div>
        </>
        :
        <div className="mt-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-2">
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">{overtime?.ots_status_id === 67 ? "Approved" : "Rejected"} Hours</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{overtime?.approved_duration_string}</span>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">Date</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(overtime?.ots_date_from)}</span>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">{overtime?.ots_status_id === 67 ? "Approved" : "Rejected"} By</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{overtime?.ots_approved_by_name}</span>
            </div>
            <div>
              <p className="text-xs text-slate-700 mb-1 dark:text-slate-100">{overtime?.ots_status_id === 67 ? "Approved" : "Rejected"} On</p>
              <span className="text-[13px] font-medium tracking-normal dark:text-white">{formatDateRange(overtime?.ots_approved_date, null, false)}</span>
            </div>
          </div>
          <div>
            {overtime?.ots_status_id === 68 && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3 mt-4">
                <p className="text-[12px] text-red-700 font-medium mb-1 dark:text-red-300">Reason</p>
                <p className="text-[13px] text-red-800 dark:text-white">{overtime?.ots_note}</p>
              </div>
            )}
          </div>
        </div>
      }

    </Card>
  );
};

export default OvertimeRequestCard;
